var lib_core = require("lib-core");

/**
 * @constructor
 */
var TrayStateMachine = function (root, model, editorModel) {
    var self = this;
    this.root = root;

    this.editorModel = editorModel;
    this.model = model;

    lib_core.StateMachine.call(self, null, null, this.model.scope());

    this.toggleTransition = self.addTransition("idle","idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.UI_TRAY_TOGGLE;
        },
        function(cEvent){
            self.model.visible(!self.model.visible());
        }
    );

    this.draggingStartTransition = self.addTransition("idle","mouse_down",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.UI_TRAY_DRAG_MOUSE_DOWN;
        },
        null
    );

    this.draggingTransition = self.addTransition("mouse_down","mouse_down",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE;
        },
        function(cEvent){
            var mouseCoord = cEvent.data('mouseCoord');
            self.model.height(self.editorModel.canvasRect().height - mouseCoord.y);
        }
    );

    this.draggingEndTransition = self.addTransition("mouse_down","idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_UP;
        },
        null
    );
};
lib_core.inherit(TrayStateMachine, lib_core.StateMachine);

module.exports = TrayStateMachine;
